// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { DateTime } from 'luxon'

// Internal Dependencies:
import Verse from './Verse'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'

// Redux:
import { getVersesData } from 'actions/votd'

class VerseList extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			selectedMonth: false,
			selectedMonthKey: 'today',
			selectedMonthRendered: DateTime.local().toFormat( 'LLLL y' )
		}

		this.state = state
	}

	componentDidMount() {
		window.scrollTo( 0, siteData.page_top_pos )
		document.querySelector( '.main' ).scrollTop = 0

		this.props.getVersesData( 'today' )
	}

	updateSelectedMonth = ( newDateTime ) => {
		const { getVersesData } = this.props
		const selectedMonthKey = newDateTime.toFormat( 'y-MM-dd' )

		getVersesData( selectedMonthKey )

		this.setState( {
			currentDateTime: newDateTime,
			selectedMonth: newDateTime.toFormat( 'MM' ),
			selectedMonthKey: selectedMonthKey,
			selectedMonthRendered: newDateTime.toFormat( 'LLLL y' )
		} )
	}

	handlePreviousMonthClick = ( e ) => {
		e.preventDefault()

		const { selectedMonth } = this.state
		let newDateTime

		if ( ! selectedMonth ) {
			newDateTime = DateTime.local()
		} else {
			newDateTime = DateTime.fromFormat( selectedMonth, 'MM' ).minus( { months: 1 } )
		}

		this.updateSelectedMonth( newDateTime )
	}

	handleNextMonthClick = ( e ) => {
		e.preventDefault()

		const { selectedMonth } = this.state
		let newDateTime

		if ( ! selectedMonth ) {
			newDateTime = DateTime.local().plus( { months: 1 } )
		} else {
			newDateTime = DateTime.fromFormat( selectedMonth, 'MM' ).plus( { months: 1 } )
		}

		this.updateSelectedMonth( newDateTime )
	}

	render() {
		const { verses, versesIsLoading } = this.props
		const { selectedMonthKey, selectedMonthRendered } = this.state

		let markup = ''

		if ( verses && verses[ selectedMonthKey ] && Object.keys( verses[ selectedMonthKey ] ).length ) {
			markup = Object.keys( verses[ selectedMonthKey ] ).map( key => {
				return <Verse data={ verses[ selectedMonthKey ][ key ] } key={ key } />
			})
		}

		return (
			<div className="votd-wrap">
				<div className="-pagination">
					<h3>{ selectedMonthRendered }</h3>

					<div className="-inner">
						<div className="button -previous" onClick={ this.handlePreviousMonthClick }>
							<i className="icon-chevron-left" aria-hidden="true"></i>
						</div>

						<div className="button -next" onClick={ this.handleNextMonthClick }>
							<i className="icon-chevron-right" aria-hidden="true"></i>
						</div>
					</div>
				</div>

				{ versesIsLoading && <LoadingSpinner /> }

				{ markup }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		versesIsLoading: state.votd.versesIsLoading,
		verses: state.votd.verses,
		isMobile: state.site.isMobile
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getVersesData( dateString ) {
			dispatch( getVersesData( dateString ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( VerseList )
